export const ugovor_o_poslovnoj_suradnji = {
    templateId: 53,
    category: 16,
    templateTitle: 'Ugovor o poslovnoj suradnji',
    templateDescription: `<p>Ugovorom o poslovnoj suradnji  ugovorne strane samostalno određuju predmet i uvjete poslovne suradnje, odnosno prava i obveze koje proizlaze iz međusobne suradnje.</p>`,
    description: `
    <h5><strong>OPIS I SVRHA DOKUMENTA</strong></h5>
    <p>Jedno od načela obveznog prava (obvezno pravo je skup pravila kojima se uređuju obvezni odnosi) je sloboda ugovaranja prema kojoj poslovni subjekti slobodno uređuju međusobne obveze, no uz ograničenje da navedeni odnosi ne budu suprotni Ustavu, prisilnim propisima i moralu društva.</p>
    <p>U tom smislu, poslovni subjekti mogu svoje odnose regulirati i ugovorom o poslovnoj suradnji uređujući međusobna prava i obveze.</p>
    <p>Ovdje napominjemo da ja za tumačenje ugovora (kao i kod svih ostalih ugovora) odlučan sadržaj međusobnih prava i obveza naveden u samom ugovoru, a naslov odnosno naziv ugovora nije bitan kod tumačenja ugovora.</p>
    <p>Ipak predlaže se da naziv/naslov ugovora ima izvorište u međusobnim pravima i obvezama ugovornih strana određenim ugovorom.</p>
    <p>S obzirom na navedeno, ugovorne strane ugovorom o poslovnoj suradnji vrlo često uređuju različite međusobne odnose te je navedeni ugovor vrlo prikladan za uređivanje viševrsnih odnosno višestrukih međusobnih prava i obveza.</p>

    <h5><strong>NAJČEŠĆE GREŠKE</strong></h5>
    <p><strong>- Ugovaranje rokova plaćanja među poduzetnicima koji odudaraju od rokova plaćanja propisanih Zakonom o financijskom poslovanju i predstečajnoj nagodbi</strong></p>
    <p>Pojašnjenje: u poslovnim transakcijama među poduzetnicima može se ugovoriti rok ispunjenja novčane obveze do 60 dana. Ako ugovorom među poduzetnicima nije ugovoren rok za ispunjenje novčane obveze, dužnik je dužan, bez potrebe da ga vjerovnik na to pozove, ispuniti novčanu obvezu u roku od 30 dana. Ipak, kod ugovora o robno trgovačkom kreditu može se ugovoriti u pisanom obliku i dulji rok ispunjenja novčane obveze, a koji rok ni u kojem slučaju ne može biti dulji od 360 dana, no pod uvjetom da takvo ugovaranje na temelju okolnosti slučaja (trgovački običaji i narav obveze i sl.) nije suprotno načelu savjesnosti i poštenja odnosno da takvim ugovaranjem nije prouzročena očigledna neravnopravnost u pravima i obvezama ugovornih strana na štetu vjerovnika novčane obveze.</p>
    <p>Rok za ispunjenje novčane obveze počinje teći od:</p>
    <p>1. dana kad je dužnik primio račun ili drugi odgovarajući zahtjev za isplatu,</p>
    <p>ili</p>
    <p>2. dana kad je vjerovnik ispunio svoju obvezu:</p>
    <p>– ako nije moguće sa sigurnošću utvrditi dan primitka računa ili drugog odgovarajućeg zahtjeva za isplatu ili,</p>
    <p>– ako je dužnik primio račun ili drugi odgovarajući zahtjev za isplatu prije negoli je vjerovnik ispunio svoju obvezu,</p>
    <p>ili</p>
    <p>3. dana isteka roka za pregled predmeta obveze (rok za pregled obveze ne može biti duži od 30 dana od primitka predmeta obveze, iznimno može i duži rok pod uvjetima određenim Zakonom), ako je ugovorom ili zakonom predviđen određeni rok za takav pregled, a dužnik je primio račun ili drugi odgovarajući zahtjev za isplatu prije isteka toga roka.</p>
    <p>Ništetna je (smatra se da nije niti ugovorena te ne proizvodi pravne učinke) odredba ugovora među poduzetnicima kojom je ugovoren:</p>
    <p>1. rok ispunjenja novčane obveze duži od 60 dana,</p>
    <p>2. rok za pregled predmeta obveze duži od 30 dana, ako na temelju okolnosti slučaja, a posebno trgovačkih običaja i naravi predmeta obveze, proizlazi da je takvom ugovornom odredbom, suprotno načelu savjesnosti i poštenja, prouzročena očigledna neravnopravnost u pravima i obvezama ugovornih strana na štetu vjerovnika novčane obveze,</p>
    <p>3. rok ispunjenja novčane obveze duži od 360 dana - a ne postoje okolnosti iz prethodne točke.</p>
    <p>Osim toga, poduzetnik koji ne ispuni novčanu obvezu u roku ugovorenom sukladno odredbama gore spomenutog Zakona, odnosno u zakonskom roku ispunjenja novčane obveze odgovara prekršajno do iznosa od 1.000.000,00 kn.</p>
    <h5><strong>PRAVNA OSNOVA</strong></h5>
    <p>Sadržaj ugovora i bitni sastojci ugovora nisu uređeni Zakonom o obveznim odnosima ili drugim propisom, nego ugovorne strane sklapaju ovaj Ugovor o poslovnoj suradnji prema općim odredbama obveznog prava.</p>
    `,

    sides: [
      {
          signature: '',
          inputs: [{
              type: "input",
              required: true,
              placeholder: 'Posl. subjekt / Ime i prezime',        
            },
            {
              type: "input",
              required: true,
              placeholder: "Ulica i kućni broj",
            },
            {
              type: "input",
              required: true,
              placeholder: "Mjesto",
            },
            {
              type: "input",
              required: true,
              placeholder: "OIB",
            },
            {
              type: "input",
              placeholder: "Zastupa (za pr. osobe)",
              inSignature: true,
            },
            {
              type: "input",
              placeholder: "Funkcija (za pr. osobe)",
              inSignature: true,
            }],
          delimiter: `i`
      },
      {
          signature: '',
          inputs: [{
              type: "input",
              required: true,
              placeholder: 'Posl. subjekt / Ime i prezime',        
            },
            {
              type: "input",
              required: true,
              placeholder: "Ulica i kućni broj",
            },
            {
              type: "input",
              required: true,
              placeholder: "Mjesto",
            },
            {
              type: "input",
              required: true,
              placeholder: "OIB",
            },
            {
              type: "input",
              mandatory: false,
              editable: true,
              placeholder: "Zastupa (za pr. osobe)",
              inSignature: true,
            },
            {
              type: "input",
              placeholder: "Funkcija (za pr. osobe)",
              inSignature: true,
            }],
      }
  ],

    headline: 'zaključuju sljedeći',
    title: 'UGOVOR O POSLOVNOJ SURADNJI',
    noArticleNumbers: false,

    articles: [
        {
            title: 'UVODNE ODREDBE',
            mandatory: false,
            statements: [
                {
                    type: 'text',
                    required: false,
                    mandatory: true,
                    editable: true,
                    content: 'Ugovorne strane suglasno utvrđuju postojanje zajedničkog i nedvojbenog interesa za uspostavom odnosa poslovne suradnje, na način kako je to navedeno daljnjim odredbama Ugovora, ali i pojedinačnih i posebnih ugovora koji su sklopljeni ili će biti sklopljeni među strankama, a vezani su uz poslovni odnos definiran ovim Ugovorom.',
                    value: '',
                }],
        },
        {
            title: 'PREDMET UGOVORA',
            mandatory: false,
            statements: [
                {
                    type: 'input',
                    mandatory: true,
                    editable: false,
                    parts: [
                      
                        { type: "text", content: "Predmet ovog Ugovora je sljedeća poslovna suradnja između ugovornih strana:" },
                        { type: "textarea", value: "", required: true  },
                        { help: 'Ovdje pobliže opisujete predmet poslovne suradnje.'},
                        { type: "text", content: "(u daljnjem tekstu: Poslovna suradnja)." },
                    ]
                },
            ],
        },
        {
            title: 'UVJETI SURADNJE',
            mandatory: false,
            statements: [
                {
                    type: 'input',
                    mandatory: true,
                    editable: false,
                    parts: [
                      
                        { type: "text", content: "Ugovorne strane će međusobno surađivati pod sljedećim uvjetima:" },
                        {type: "textarea", value: "", required: true },
                        { help: 'Ovdje pobliže opisujete uvjete suradnje odnosno poslovnog dogovora, npr. - količine robe, cijene, isporuku, rokove i način plaćanja i sl. ili vrste usluga, cijenu usluge, isporuku, rokove i način plaćanja.'},
                    ]
                },
            ],
        },
            {
                title: 'OBVEZE UGOVORNIH STRANA',
                mandatory: false,
                statements: [
                    {
                        type: 'input',
                        mandatory: true,
                        editable: false,
                        parts: [
                          
                            { type: "input", value: "", required: true, placeholder: "Naziv ugovorne strane" },
                            { type: "text", content: "ima sljedeće obveze:" },
                            { type: "textarea", value: "", required: true },
                            { help: 'Ovdje pobliže opisujete obveze prve ugovorne strane.'},
                            { type: "text", content: ", a" },
                            { type: "input", value: "", required: true,  placeholder: "Naziv ugovorne strane"  },
                            { type: "text", content: "ima sljedeće obveze:" },
                            { type: "textarea", value: "",required: true },
                            { help: 'Ovdje pobliže opisujete obveze druge ugovorne strane.'},
                        ]
                    },
                ],
            },
        {
            title: 'TRAJANJE UGOVORA',
            mandatory: false,
            statements: [
                {
                    type: 'choice',
                    mandatory: true,
                    editable: false,
                    choices: [
                        {
                            parts: [
                                {
                                    type: 'text',
                                    content: 'Ovaj Ugovor zaključuje se isključivo za poslovnu suradnju u ovom Ugovoru kako je to prethodno definirano i prestaje urednim izvršenjem svih međusobnih obveza ugovorenih strana iz ovog Ugovora.'
                                }]
                        },
                        {
                            parts: [
                                {type: 'text', content: 'Ovaj Ugovor se zaključuje na razdoblje od'},
                                {type: 'input', value: '', required: true, help: 'Upišite datum početka suradnje.'},
                                {type: 'text', content: 'do'},
                                {type: 'input', value: '', required: true, help: 'Upišite datum završetka suradnje.'},
                                {type: 'text', content: '.'}]
                        }],
                    value: '',
                }
            ]
        },
     
{
    title: 'OTKAZ UGOVORA',
    mandatory: false,
    statements: [
        {
            type: 'input',
            mandatory: true,
            editable: false,
            parts: [
                {
                    type: 'text',
                    content: 'Svaka ugovorna strana može jednostrano, pisanim putem, bez navođenja razloga, pisanim putem otkazati ovaj Ugovor uz otkazni rok od'
                },
                {type: 'input', value: '', required: true, help: 'Upisati otkazni rok.'},
                {type: 'text', content: 'dana, a koji počinje teći od trenutka dostave otkaza drugoj ugovornoj strani.'},
                            {type: 'text', newline:"true", content: '\r\nUčinci takvog prestanka ugovora uslijed otkaza su sljedeći:', help: 'Učinke otkaza možete ugovarati slobodno po vlastitom nahođenju, kao i eventualne ugovorne kazne.'},
                            { type: "textarea", value: "", required: true },
                            { help: 'Ovdje definirate učinke prestanka ugovora uslijed otkaza.',}],
        }],
},

{
    title: 'RASKID UGOVORA',
    mandatory: false,
    statements: [
        {
            type: 'input',
            mandatory: true,
            editable: false,
            parts: [
                {
                    type: 'text', content: 'U slučaju da jedna ugovorna strana krši obveze iz ovog Ugovora, druga strana može pisanim putem jednostrano raskinuti ugovor uz otkazni rok od' },
                    {type: 'input', value: '', required: true, help: 'Upisati otkazni rok.'},
                    {type: 'text', content: ', a koji počinje teći od trenutka dostave raskida drugoj ugovornoj strani.'},
                    {type: 'text', newline:"true", content: '\r\nPosljedice takvog raskida su sljedeće:'},
                    { type: "textarea", value: "", required: true },
                    { help: 'Učinke raskida možete ugovarati slobodno po vlastitom nahođenju, kao i eventualne ugovorne kazne.'}
                        ],
        }],
},
{
    title: 'DOSTAVA',
    mandatory: false,
    exampleContent: true,
    statements: [
        {
            type: 'text',
            required: true,
            mandatory: true,
            editable: true,
            content: 'U slučaju otkaza i raskida Ugovora, isti se mora drugoj ugovornoj strani dostaviti preporučenom pošiljkom putem pošte na adresu označenu u ovom Ugovoru ili na drugi pouzdan način.\r\nU slučaju nemogućnosti uredne osobne dostave pisane opomene i dostave otkaza zbog promjene adrese, odbijanja preuzimanja pismena ili drugih načina izbjegavanja primanja pismena, dostava se smatra uredno izvršenom danom predaje preporučene pošiljke pošti, bez obzira na to je li pošta bila u mogućnosti uručiti pisanu opomenu, odnosno otkaz ili drugo pismeno.  ',
            value: '',
        },
    ],
    value: '',
}, 
        {
            title: 'NADLEŽNOST',
            mandatory: false,
            statements: [
                {
                    type: 'choice',
                    mandatory: true,
                    editable: false,
                    choices: [
                      
                        {
                            parts: [
                                {
                                    type: 'text',
                                    content: 'Svi sporovi koji proizađu ili budu u vezi s ovim Ugovorom rješavati će se pred stvarno nadležnim sudom prema sjedištu'
                                },
                                {type: 'input', value: '',help: "Upišite naziv ugovorne strane prema čijem sjedištu će biti određena nadležnost suda.", required: true},
            ]
                        },
                        {
                            parts: [
                                {
                                    type: 'text',
                                    content: 'Svi sporovi koji proizađu ili budu u vezi s ovim Ugovorom rješavati će se pred stvarno nadležnim sudom u'
                                },
                                {type: 'input', value: '',help: "Upišite mjesno nadležni sud. Npr. sudom u Zagrebu; sudom u Splitu i sl..", required: true},
            ]
                        }
                    ],
                    value: '',
                }
            ]
        },
        {
            title: 'MJERODAVNO PRAVO',
            mandatory: false,
            statements: [
                {
                    type: 'text',
                    required: false,
                    mandatory: true,
                    editable: true,
                    content: 'Na prava i obveze ugovornih stranaka, koja nisu uređena ovim Ugovorom, primjenjuju se odredbe Zakona o obveznim odnosima.',
                    value: '',
                }],
        },
        {
            title: 'PRIMJENA UGOVORA',
            mandatory: false,
            statements: [
                {
                    type: 'text',
                    required: false,
                    mandatory: true,
                    editable: true,
                    content: 'Ovaj Ugovor se primjenjuje od trenutka potpisa ugovornih strana.',
                    value: '',
                }],
        },
        {
            title: 'PRIMJERCI UGOVORA',
            mandatory: false,
            statements: [
                {
                    type: 'text',
                    required: false,
                    mandatory: true,
                    editable: true,
                    content: 'Ovaj Ugovor sastavljen je u 2 (dva) primjerka, od kojih svaka ugovorna strana zadržava po 1 (jedan) primjerak.',
                    value: '',
                }],
          },
        {
            mandatory: true,
            static: true,
            type: 2, // date and place
            statements: [
              {
                type: "input",
                mandatory: true,
                parts: [
                  {
                    type: "text",
                    content: "U"
                  },
                  {
                    type: "input",
                    value: "",
                    placeholder: "Upišite mjesto.",
                    required: true,
                  },
                  {
                    type: "text",
                    content: ", dana"
                  },
                  {
                    type: "date",
                    value: new Date(),
                    required: true
                  },
                  {
                    type: "text",
                    content: "godine."
                  }
                ]
              },
            ]
          },
        {
            mandatory: true,
            static: true,
            type: 3,  // signatures
            statements: [],
        },
    ],
};



// WEBPACK FOOTER //
// C:/Projects/milic/self-legal/src/app/contracts/53_ugovor_o_poslovnoj suradnji.ts